import {useActions, useGetters, useMutators, useState} from './_default.js';
import axios from "axios";
export default {
    namespaced: true,
    state: {
        ...useState(),
        interval: 5000,
        time: null,
        ids: [],
        timer: null,
    },
    getters: {
        ...useGetters(),
        ids: state => state.ids,
    },
    mutations: {
        ...useMutators(),
    },
    actions: {
        ...useActions(),
        addId({state, dispatch }, id) {
            const index = state.ids.findIndex(i => i.toString() === id.toString());
            if (index !== -1) return;
            state.ids.push(id);
            return dispatch('loadObject', id);
        },

        removeId({ state }, id) {
            const index = state.ids.findIndex(i => i.toString() === id.toString());
            if (index === -1) return;
            state.ids.splice(index, 1);
        },

        loadObject({ state, commit, dispatch }, id) {
            return new Promise((resolve, reject) => {
                axios.get('/payload/paginated/map/object', {
                    params: { id }
                }).then((response) => {
                    const data = response.data.data.data;
                    const item = data.length ? data[0] : null;
                    if (!item) return;
                    commit('addToList', item);
                    dispatch('addId', item.id);
                    resolve(item);
                });
            });
        },

        watch({ state, dispatch }) {
            if (state.timer) return;
            if (!state.ids.length) {
                state.time = null;
                return;
            }
            clearTimeout(state.timer);
            state.timer = setTimeout(() => {
                dispatch('update').then(() => {
                    state.timer = null;
                    if (!state.ids.length) {
                        state.time = null;
                        return;
                    }
                    dispatch('watch');
                });
            }, state.interval);
        },

        update({ state, commit }) {
            return new Promise((resolve, reject) => {
                axios.get('/payload/paginated/map/object', {
                    params: {
                        fallow: state.ids,
                        time: state.time,
                    }
                }).then((response) => {
                    state.time = response.headers?.time;
                    response.data.data.data.forEach((item) => {
                        commit('updateOrAddToList', item);
                    });

                    resolve();
                });
            });
        }
    },
}
